import React, { lazy } from 'react';
import { CheckCircle2, Gift } from 'lucide-react';
export function BonusSection() {
  const bonos = [{
    id: 1,
    badge: 'BONO #1 — VALOR: 47€ — GRATIS',
    title: '⚡ UGC STARTER KIT EXPRESS (48H)',
    desc: 'Tu primer portfolio listo para enviar a marcas en 48 horas.',
    bullets: ['Los 3 videos de portfolio que más contratan las marcas', 'La estructura exacta de carpetas Drive "modo pro"', 'Plan día a día (hora por hora) para las 48 horas', 'Checklist final de calidad antes de compartir', 'Mini-FAQ para los 10 bloqueos más comunes'],
    img: 'https://cdn.magicpatterns.com/uploads/kTPoSQqiiJTGqKUi8HZrBR/bono_1_cv.png'
  }, {
    id: 2,
    badge: 'BONO #2 — VALOR: 47€ — GRATIS',
    title: '⚡ BIBLIOTECA ANTI-RECHAZO',
    desc: '25 objeciones reales de marcas y las respuestas exactas que cierran.',
    bullets: ['Las 5 familias de objeciones y cómo diagnosticarlas', 'Respuesta exacta para "es caro", "no tenemos presupuesto" y más', '3 mini-propuestas listas para enviar por DM o email', 'Cheat sheet de 1 página para usar mientras negocias', 'Tracker de negociaciones printable'],
    img: 'https://cdn.magicpatterns.com/uploads/sL858vxmjbuUCmrfUpFTrG/bono_2_cv.png'
  }, {
    id: 3,
    badge: 'BONO #3 — VALOR: 47€ — GRATIS',
    title: '⚡ CALENDARIO 30D "INGRESO EXTRA"',
    desc: 'Plan diario de 15 minutos para conseguir oportunidades sin quemarte.',
    bullets: ['Sistema 5/5/5: Encontrar, contactar y registrar en 15 min/día', 'Calendario día por día con tareas específicas', 'Scoreboard semanal para medir progreso sin ansiedad', 'Micro-mensajes listos para copiar y pegar', 'La regla 7/14/30 de follow-up que cierra más'],
    img: 'https://cdn.magicpatterns.com/uploads/9ATpN1Lyb9r8nQEDa4sWpj/bono_3_cv.png'
  }];
  return <section className="bg-black py-20 px-4 border-t-4 border-neon" data-id="element-19">
      <div className="max-w-4xl mx-auto" data-id="element-20">
        <div className="text-center mb-10" data-id="element-21">
          <span className="text-black font-bold text-sm tracking-widest uppercase bg-neon px-4 py-1 rounded-full" data-id="element-22">
            — PERO ESO NO ES TODO —
          </span>
        </div>

        <h2 className="text-3xl md:text-5xl font-extrabold text-white text-center leading-tight mb-6 font-montserrat" data-id="element-23">
          "Cuando Pides El Método 500€ Hoy, También Recibes GRATIS Estos 3 Bonos
          Exclusivos"
        </h2>

        <p className="text-gray-400 italic text-center text-xl mb-16" data-id="element-24">
          "Valorados en 141€. Tuyos hoy sin coste adicional."
        </p>

        <div className="space-y-16 mb-20" data-id="element-25">
          {bonos.map(bono => <div key={bono.id} className="bg-gray-900 rounded-3xl border-2 border-orange-500 overflow-hidden shadow-[0_0_30px_rgba(249,115,22,0.3)]" data-id="element-26">
              <div className="bg-orange-500 text-black font-black text-center py-3 text-lg md:text-xl tracking-wider uppercase flex items-center justify-center gap-2" data-id="element-27">
                <Gift className="w-6 h-6" data-id="element-28" />
                {bono.badge}
              </div>

              <div className="p-6 md:p-10 flex flex-col md:flex-row gap-10 items-center" data-id="element-29">
                <div className="w-full md:w-1/2 flex-shrink-0 cursor-pointer group" onClick={() => document.getElementById('compra')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-30">
                  <div className="relative aspect-square max-w-[400px] mx-auto overflow-hidden rounded-xl border-4 border-gray-800 group-hover:border-neon transition-colors duration-300 bg-gray-950" data-id="element-31">
                    <img src={bono.img} alt={bono.title} width={1080} height={1080} loading="lazy" decoding="async" className="w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-500" data-id="element-32" />
                  </div>
                </div>

                <div className="w-full md:w-1/2" data-id="element-33">
                  <h3 className="text-2xl md:text-3xl font-black text-white mb-4" data-id="element-34">
                    {bono.title}
                  </h3>

                  <p className="text-gray-300 italic mb-8 text-lg border-l-4 border-orange-500 pl-4" data-id="element-35">
                    {bono.desc}
                  </p>

                  <ul className="space-y-4 mb-8" data-id="element-36">
                    {bono.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-3 text-white" data-id="element-37">
                        <CheckCircle2 className="w-6 h-6 text-neon shrink-0 mt-0.5" data-id="element-38" />
                        <span className="text-lg" data-id="element-39">{bullet}</span>
                      </li>)}
                  </ul>

                  <div className="bg-black/50 p-4 rounded-lg border border-gray-800 text-center" data-id="element-40">
                    <p className="text-2xl font-black text-neon" data-id="element-41">
                      TUYO GRATIS HOY
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-neon rounded-2xl p-6 md:p-10 shadow-neon-lg border-4 border-white text-black max-w-2xl mx-auto" data-id="element-42">
          <h3 className="text-2xl md:text-3xl font-black text-center mb-8 uppercase tracking-tight border-b-4 border-black pb-4" data-id="element-43">
            RESUMEN COMPLETO DE TU PEDIDO:
          </h3>

          <div className="space-y-4 text-lg md:text-xl font-bold mb-8" data-id="element-44">
            <div className="flex justify-between items-center border-b border-black/20 pb-2" data-id="element-45">
              <span data-id="element-46">5 Tomos El Método 500€</span>
              <span data-id="element-47">295€</span>
            </div>
            <div className="flex justify-between items-center border-b border-black/20 pb-2" data-id="element-48">
              <span data-id="element-49">Bono 1: Starter Kit 48H</span>
              <span data-id="element-50">47€</span>
            </div>
            <div className="flex justify-between items-center border-b border-black/20 pb-2" data-id="element-51">
              <span data-id="element-52">Bono 2: Biblioteca Anti-Rechazo</span>
              <span data-id="element-53">47€</span>
            </div>
            <div className="flex justify-between items-center border-b border-black/20 pb-2" data-id="element-54">
              <span data-id="element-55">Bono 3: Calendario 30D</span>
              <span data-id="element-56">47€</span>
            </div>
          </div>

          <div className="border-t-4 border-black pt-6" data-id="element-57">
            <div className="flex justify-between items-center text-xl md:text-2xl font-black text-gray-800 mb-2" data-id="element-58">
              <span data-id="element-59">VALOR TOTAL:</span>
              <span className="line-through" data-id="element-60">436€</span>
            </div>
            <div className="flex justify-between items-center text-3xl md:text-5xl font-black mt-4 bg-black text-neon p-4 rounded-xl" data-id="element-61">
              <span data-id="element-62">TU PRECIO HOY:</span>
              <span data-id="element-63">17.99€ ✅</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}